import React, { useState } from "react";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Accuracy_table() {
  const data = [
    {
      srNo: 101,
      type: "Use Of CRM",
      accepted: "Accepted",
      rows: [
        { param: "ASH%", certified: "26.50", tested: "26.50" },
        { param: "VM%", certified: "26.50", tested: "26.50" },
        { param: "GCV(K.Cal/Kg)", certified: "26.50", tested: "26.50" },
      ],
    },
  ];

     const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <section className="Imperiality_table">
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped customer_table">
            <thead>
              <tr>
                <th rowSpan="2">Sr. No</th>
                <th rowSpan="2">Type Verification Of</th>
                <th colSpan="2">Certified</th>
                <th rowSpan="2">Tested Value</th>
                <th rowSpan="2">Accuracy Acceptance</th>
              </tr>
              <tr>
                <th>Parameter</th>
                <th>Value</th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, index) =>
                item.rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {rowIndex === 0 && (
                      <>
                        <td rowSpan={item.rows.length}>{item.srNo}</td>
                        <td rowSpan={item.rows.length}>{item.type}</td>
                      </>
                    )}

                    <td>{row.param}</td>
                    <td>{row.certified}</td>
                    <td>{row.tested}</td>

                    {rowIndex === 0 && (
                      <td rowSpan={item.rows.length}>{item.accepted}</td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

       <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}

export default Accuracy_table;
